class Inquiry {
	constructor({
		id = '',
		name = '',
		email = '',
		categ = '',
		message = '',
		phone = '',
		nationality = '',
		status = '',
		handlerId = '',
		lastPublicKind = '',
		createdAt = '',
		updatedAt = '',
		receivedAt = '',
		receivedBy = '',
		responsedAt = '',
		responsedBy = '',
		completedAt = '',
		completedBy = '',
		images = [] as string[],
	} = {}) {
		this.id = id === null ? '' : id
		this.name = name === null ? '' : name
		this.email = email === null ? '' : email
		this.categ = categ === null ? '' : categ
		this.message = message === null ? '' : message
		this.phone = phone === null ? '' : phone
		this.nationality = nationality === null ? '' : nationality
		this.status = status === null ? '' : status
		this.handlerId = handlerId === null ? '' : handlerId
		this.lastPublicKind = lastPublicKind === null ? '' : lastPublicKind
		this.createdAt = createdAt === null ? '' : createdAt
		this.updatedAt = updatedAt === null ? '' : updatedAt
		this.receivedAt = receivedAt === null ? '' : receivedAt
		this.receivedBy = receivedBy === null ? '' : receivedBy
		this.responsedAt = responsedAt === null ? '' : responsedAt
		this.responsedBy = responsedBy === null ? '' : responsedBy
		this.completedAt = completedAt === null ? '' : completedAt
		this.completedBy = completedBy === null ? '' : completedBy
		this.images = Array.isArray(images) ? images : []
	}
	id: string
	name: string
	email: string
	categ: string
	message: string
	phone: string
	nationality: string
	status: string
	handlerId: string
	lastPublicKind: string
	createdAt: string
	updatedAt: string
	receivedAt: string
	receivedBy: string
	responsedAt: string
	responsedBy: string
	completedAt: string
	completedBy: string
	/** 첨부 이미지 S3 링크 — 상세 조회에서만 채워진다 */
	images: string[]
}

export { Inquiry }
